module.exports = __webpack_public_path__ + "img/2021_10_dande_kiyomizu_1011_fin_web.41895b1b.jpg";